var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mt-3"},[_c('v-card-title',[_vm._v("Informacje do zadań")]),_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.content)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }